import { useShallow } from 'zustand/react/shallow';
import { useApplicationContext } from '../../../modules/context/ApplicationContext/ApplicationContext';
import useGeneralSettingsStore from '../useGeneralSettingsStore';

const usePaymentReleaseSettings = () => {
  const { brandPaymentGateways } = useApplicationContext();

  const { requirePaymentReleaseForImmediate, requirePaymentReleaseForPreOrder } =
    useGeneralSettingsStore(
      useShallow((state) => ({
        requirePaymentReleaseForImmediate:
          !!state.generalSettings.requirePaymentReleaseForImmediate,
        requirePaymentReleaseForPreOrder: !!state.generalSettings.requirePaymentReleaseForPreOrder,
      })),
    );

  return {
    requirePaymentReleaseForImmediate,
    requirePaymentReleaseForPreOrder,
    refundLimitHours: brandPaymentGateways?.[0]?.refundLimitHours ?? 0,
  };
};

export default usePaymentReleaseSettings;
